import React, { Component } from "react";
import { StringToColor } from "../util/Helper";
class ImageOrInitial extends Component {
  
  render() {
    const bgStyle = {
      backgroundColor: StringToColor(this.props.name)
    };
    

    var _letter = this.props.name ? this.props.name.charAt(0) : "";

    if(this.props.image){
      return (
        <img src={this.props.image} className={this.props.className}/>
      );
    }
    else{
      return (
		      <label style={bgStyle} className={this.props.className}>{_letter}</label>
      );
    }
   
  }
}
 
export default ImageOrInitial;